import React from "react";
import CustomModal from "../../../../../components/CustomModal";
import { IAuditoriaEntradaSaida } from "../types/types";

interface Props {
  data?: IAuditoriaEntradaSaida;
  onClose: () => void;
  title: string;
  cancelaName?: string;
}

const safeParseJson = (val: any) => {
  if (!val) return null;
  if (typeof val === "object") return val;
  try {
    return JSON.parse(val);
  } catch {
    return val;
  }
};

const Info: React.FC<Props> = ({ data, onClose, title, cancelaName }) => {
  if (!data) return null;

  const parsedBody = safeParseJson(data.body);
  const parsedOpenCancela = safeParseJson(data.open_cancela);
  const parsedResponse = safeParseJson(data.response);

  const statusVal = parsedOpenCancela?.status;
  const isSuccess = statusVal === 200 || statusVal === "200";

  const placa = parsedBody?.placa || parsedBody?.placa_dianteira || parsedBody?.placaDianteira || "---";
  const camId = parsedBody?.camId || parsedBody?.id_cancela || "---";

  const formattedDate = data.data_historico
    ? new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(new Date(data.data_historico.replace(" ", "T")))
    : "---";

  return (
    <CustomModal title={title} onClose={onClose} isScreenLg>
      <div className="w-full p-4 flex flex-col gap-6 max-h-[80vh] overflow-y-auto">
        {/* Resumo no topo */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-[#F8FAFC] border border-[#E2E8F0] p-4 rounded-xl">
          <div>
            <span className="text-xs font-semibold text-gray-500 block uppercase">ID Requisição</span>
            <strong className="text-base text-gray-900 font-bold">#{data.id}</strong>
          </div>
          <div>
            <span className="text-xs font-semibold text-gray-500 block uppercase">Placa</span>
            <strong className="text-base text-gray-900 font-bold">{placa}</strong>
          </div>
          <div>
            <span className="text-xs font-semibold text-gray-500 block uppercase">Cancela (camId)</span>
            <strong className="text-base text-gray-900 font-bold">
              {cancelaName || (camId !== "---" ? `Cancela ${camId}` : "---")}
            </strong>
          </div>
          <div>
            <span className="text-xs font-semibold text-gray-500 block uppercase">Status da Abertura</span>
            <span
              className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold mt-1 ${
                isSuccess
                  ? "bg-emerald-100 text-emerald-800 border border-emerald-300"
                  : "bg-rose-100 text-rose-800 border border-rose-300"
              }`}
            >
              {isSuccess ? "Abriu (200 OK)" : `Não Abriu (${statusVal ?? "Sem retorno"})`}
            </span>
          </div>
        </div>

        <div>
          <span className="text-xs font-semibold text-gray-500 block mb-1">Data / Hora do Registro</span>
          <span className="text-sm font-medium text-gray-800">{formattedDate}</span>
        </div>

        {/* JSON Body */}
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-bold text-[#071B3A]">Dados da Requisição (Body)</h3>
          <pre className="bg-[#0F172A] text-[#F8FAFC] p-4 rounded-xl text-xs overflow-x-auto font-mono shadow-inner">
            {parsedBody ? JSON.stringify(parsedBody, null, 2) : "Nenhum dado informado"}
          </pre>
        </div>

        {/* JSON Open Cancela */}
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-bold text-[#071B3A]">Retorno Dispositivo / Cancela (open_cancela)</h3>
          <pre className="bg-[#0F172A] text-[#F8FAFC] p-4 rounded-xl text-xs overflow-x-auto font-mono shadow-inner">
            {parsedOpenCancela ? JSON.stringify(parsedOpenCancela, null, 2) : "Nenhum retorno recebido"}
          </pre>
        </div>

        {/* JSON Response */}
        {parsedResponse && (
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-bold text-[#071B3A]">Resposta da API (Response)</h3>
            <pre className="bg-[#0F172A] text-[#F8FAFC] p-4 rounded-xl text-xs overflow-x-auto font-mono shadow-inner">
              {JSON.stringify(parsedResponse, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default Info;
